import React, { useEffect, useState } from "react";
import { toast, Button, ChipIcon, Dialog, Typography } from "@picklebet/ui";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { casinoService } from "@/features/casino/services/casino";
import { convertErrorToToast } from "@/utilities/errorsParser";
import { flex } from "@/features/casino/components/SharedStyles.module.scss";
import {
  endSessionModalContentContainer,
  endSessionModalBtn,
} from "@/features/casino/components/EndAllGameSessionsConfirmationModal.module.scss";
import { useGameSessions } from "@/features/casino/hooks/useGameSessions";

const EndAllGameSessionsConfirmationModal = () => {
  const modal = useShellStore((state) => state.modal);
  const setModal = useShellStore((state) => state.setModal);
  const [isLoading, setIsLoading] = useState(false);
  const isOpen = modal === "endGameSession";

  const { hasActiveGameSession, isLoading: isLoadingGameSession } =
    useGameSessions(true);

  const handleClose = () => setModal(null);

  const handleEndAllGamingSessions = async () => {
    setIsLoading(true);
    try {
      const result = await casinoService.endAllGamingSessions();
      if (result.ok) {
        toast({
          description: "Your Casino session has ended",
        });
        handleClose();
      }
    } catch (error) {
      toast(
        convertErrorToToast(error, {
          title: "Unable to end Casino session.",
        }),
      );
    }
    setIsLoading(false);
  };

  useEffect(() => {
    // if we don't have an active session and this is open, we can close it
    if (!isLoadingGameSession && !hasActiveGameSession && isOpen) {
      handleClose();
    }
  }, [hasActiveGameSession, isLoadingGameSession, isOpen]);

  return (
    <Dialog
      onClose={handleClose}
      isOpen={isOpen}
      title={`End Casino Session`}
      icon={<ChipIcon width={28} height={28} />}
    >
      <div className={endSessionModalContentContainer}>
        <Typography variant="body" noSpacing>
          Ending your Casino session will close all active games and let you
          access your balance to bet and withdraw.
        </Typography>
      </div>
      <div className={flex}>
        <Button
          onClick={handleEndAllGamingSessions}
          size={`md`}
          variant={`primary`}
          loading={isLoading}
          className={endSessionModalBtn}
        >
          End Session
        </Button>
        <Button onClick={handleClose} size={`md`} variant={`blurred`}>
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};

export { EndAllGameSessionsConfirmationModal };
